module.exports = __webpack_public_path__ + "img/PM10.68c95075.png";